import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { environment } from 'src/environments/environment';

import {
  AddCalculationRequest,
  CalculationDetailResponse,
  GetCalculationsRequest,
  GetCalculationsResponse,
  UpdateCalculationRequest,
} from '../types/models';

@Injectable()
export class CalculationService {
  id: string | undefined = '';
  constructor(private httpClient: HttpClient) {}

  getCalculations(
    request: GetCalculationsRequest
  ): Observable<GetCalculationsResponse> {
    // let params = new HttpParams();
    // if (request?.sortNames?.length) {
    //   params = params.append('SortNames', request.sortNames);
    //   params = params.append('SortType', request?.sortType || 0);
    // }
    // if (request?.pageSize && request?.pageNumber) {
    //   params = params.append('PageSize', request.pageSize);
    //   params = params.append('PageIndex', request.pageNumber);
    // }
    // return this.httpClient.get<GetCalculationsResponse>(
    //   `${environment.apiUrl}/Metadata/Calculations`,
    //   { params }
    // );

    // TODO remove when complete module entity
   return of();
  }

  addCalculation(request: AddCalculationRequest): Observable<void> {
    // return this.httpClient.post<void>(
    //   `${environment.apiUrl}/Metadata/AddCalculation`,
    //   { ...request }
    // );

    // TODO remove when complete module entity
   return of();
  }

  updateCalculation(body: UpdateCalculationRequest) {
    // return this.httpClient.put(
    //   `${environment.apiUrl}/Metadata/Calculation/${body.id}`,
    //   body
    // );

    // TODO remove when complete module entity
   return of();
  }

  removeCalculation(id: string): Observable<void> {
    // return this.httpClient.delete<void>(
    //   `${environment.apiUrl}/Metadata/Calculation/${id}`
    // );

    // TODO remove when complete module entity
   return of();
  }

  getCalculationProperties(): Observable<any> {
    // return this.httpClient.get<any>(
    //   `${environment.apiUrl}/Metadata/GetCalculationProperties`
    // );

    // TODO remove when complete module entity
   return of();
  }

  getCalculationDetail(id: string): Observable<CalculationDetailResponse> {
    // return this.httpClient.get<CalculationDetailResponse>(
    //   `${environment.apiUrl}/Metadata/Calculation/${id}`
    // );

    // TODO remove when complete module entity
   return of();
  }

  getMemberId(id: string) {
    return this.httpClient.get(`${environment.apiUrl}/Members/` + id);
  }

  validateCalculationName = (body: any) => {
    // return this.httpClient.post(
    //   `${environment.apiUrl}/Metadata/Calculation/Exists`,
    //   body
    // );

    // TODO remove when complete module entity
   return of();
  };
}
